<template>
  <div>
    <h2>Pillars</h2>
      <div v-if="creator.strategy.pillars.length" class="strategy-board">
        <div v-for="pillar in creator.strategy.pillars" :key="pillar.pillarID" class="strategy-pillar-card">
          <div class="pillar-description">
            <h4 v-b-modal="'pillarDetails'+pillar.pillarID" @click="clonePillar(pillar)">{{pillar.data.pillarName}}</h4>
            <i class="fa fa-trash strategy" v-b-modal="'pillarDelete'+pillar.pillarID"></i>
            <p v-b-modal="'pillarDetails'+pillar.pillarID" @click="clonePillar(pillar)" class="artist">{{pillar.data.pillarDescription}}</p>
          </div>
          <b-modal :id="'pillarDetails'+pillar.pillarID" :title="pillar.data.pillarName" v-if="pillarClone" centered @ok="updatePillar(pillar)">
            <b-form>
              <b-form-group label="Title">
                <b-form-input
                  v-model="pillarClone.data.pillarName">
                </b-form-input>
              </b-form-group>
              <b-form-group label="Description">
                <b-form-textarea
                  v-model="pillarClone.data.pillarDescription">
                </b-form-textarea>
              </b-form-group>
            </b-form>
          </b-modal>
          <b-modal
            :id="'pillarDelete'+pillar.pillarID"
            :title="'Are you sure you want to delete pillar: ' + pillar.data.pillarName + '?'"
            centered
            @ok="removePillar(pillar)"
          >
          </b-modal>
        </div>
        <button v-if="creator.strategy.pillars.length < 5" class="keyword-button" v-b-modal.newPillar>+</button>
      </div>
      <!-- <div v-if="strategy.pillars.pillar1 || strategy.pillars.pillar2 || strategy.pillars.pillar3 || strategy.pillars.pillar4 || strategy.pillars.pillar5" class="strategy-board">
        <div v-if="strategy.pillars.pillar1" class="strategy-pillar-card" @click="selectPillar(strategy.pillars.pillar1)" v-b-modal.pillarDetails>
          <div class="pillar-description">
            <h4>{{strategy.pillars.pillar1.pillarName}}</h4>
            <p class="artist">{{strategy.pillars.pillar1.description}}</p>
          </div>
        </div>
        <div v-if="strategy.pillars.pillar2" class="strategy-pillar-card" @click="selectPillar(strategy.pillars.pillar2)" v-b-modal.pillarDetails>
          <div class="pillar-description">
            <h4>{{strategy.pillars.pillar2.pillarName}}</h4>
            <p class="artist">{{strategy.pillars.pillar2.description}}</p>
          </div>
        </div>
        <div v-if="strategy.pillars.pillar3" class="strategy-pillar-card" @click="selectPillar(strategy.pillars.pillar3)" v-b-modal.pillarDetails>
          <div class="pillar-description">
            <h4>{{strategy.pillars.pillar3.pillarName}}</h4>
            <p class="artist">{{strategy.pillars.pillar3.description}}</p>
          </div>
        </div>
        <div v-if="strategy.pillars.pillar4" class="strategy-pillar-card" @click="selectPillar(strategy.pillars.pillar4)" v-b-modal.pillarDetails>
          <div class="pillar-description">
            <h4>{{strategy.pillars.pillar4.pillarName}}</h4>
            <p class="artist">{{strategy.pillars.pillar4.description}}</p>
          </div>
        </div>
        <div v-if="strategy.pillars.pillar5" class="strategy-pillar-card" @click="selectPillar(strategy.pillars.pillar5)" v-b-modal.pillarDetails>
          <div class="pillar-description">
            <h4>{{strategy.pillars.pillar5.pillarName}}</h4>
            <p class="artist">{{strategy.pillars.pillar5.description}}</p>
          </div>
        </div>
        <button v-if="!strategy.pillars.pillar1 || !strategy.pillars.pillar2 || !strategy.pillars.pillar3 || !strategy.pillars.pillar4 || !strategy.pillars.pillar5" class="keyword-button" @click="getInactivePillars" v-b-modal.newPillar>+</button>
      </div> -->
      <div v-else class="strategy-board">
        <h4>No pillar topics yet!
          <br>Add one now
        </h4>
        <button class="keyword-button" v-b-modal.newPillar>+</button>
      </div>
      <b-modal id="newPillar" title="Add New Pillar" @ok="createPillar()" centered>
        <b-form>
          <!-- <div>
            <b-dropdown id="dropdown-divider" :text="dropdownTitle" class="m-2">
              <b-dropdown-item-button @click="showNewPillarInput">Create New Pillar</b-dropdown-item-button>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-group id="dropdown-group-1" header="Existing Pillars">
                <b-dropdown-item-button v-for="pillar in creator.strategy.inactivePillars" :key="pillar.pillarID" @click="addExistingPillar(pillar.pillarID, pillar.pillarName, pillar.description)">{{pillar.data.pillarName}}</b-dropdown-item-button>
              </b-dropdown-group>
            </b-dropdown>
          </div> -->
          <b-form-group description="What's your pillar topic?">
            <b-form-input
              id="input-1"
              v-model="pillarName"
              type="text"
              placeholder="Pillar name..."
              autocomplete="off"
              required>
            </b-form-input>
          </b-form-group>
        </b-form>
      </b-modal>
      <!-- <b-modal id="pillarDetails" :title="selectedPillar.pillarName" centered @ok="updatePillar">
        <b-form>
          <b-form-group label="Title">
            <b-form-input
              v-model="selectedPillar.pillarName">
            </b-form-input>
          </b-form-group>
          <b-form-group label="Description">
            <b-form-textarea
              v-model="selectedPillar.description">
            </b-form-textarea>
          </b-form-group>
          <b-form-group label="Active" description="Switch pillar to inactive.">
            <b-form-checkbox switch
              id="input-1"
              checked="true"
              type="checkbox"
              @change="deactivatePillar">
            </b-form-checkbox>
          </b-form-group>
        </b-form>
      </b-modal> -->
  </div>
</template>
<script>
import { mapState } from 'vuex'
// import { firebaseDatabase, firebaseAuth } from '@/services/firebase'

export default {
  name: 'pillars',
  data() {
    return {
      // pillarID: null,
      pillarName: null,
      description: null,
      pillarClone: null,
      // userID: null,
      // active: null,
      // allPillars: [],
      // isVisibleNewPillarInput: false,
      // isVisibleExistingPillarInput: false,
      // dropdownTitle: 'Choose Pillar',
      // selectedPillar: {
      //   data: {
      //     pillarName: null,
      //     pillarDescription: null,
      //   },
      // },
    }
  },
  computed: {
    ...mapState(['creator']),
    // ...mapState(['strategy']),
  },
  created() {
  },
  methods: {
    // getInactivePillars() {
    //   const pillars = []
    //   firebaseDatabase.collection('pillars')
    //     .where('userID', '==', firebaseAuth.currentUser.uid)
    //     .where('active', '==', false)
    //     .get()
    //     .then(querySnapshot => {
    //       querySnapshot.forEach(doc => {
    //         const data = {
    //           pillarID: doc.id,
    //           pillarName: doc.data().pillarName,
    //           active: doc.data().active,
    //           userID: doc.data().userID,
    //           description: doc.data().description,
    //         }
    //         pillars.push(data)
    //       })
    //     })
    //   this.allPillars = pillars
    // },
    // selectPillar(pillar) {
    //   this.selectedPillar = pillar
    //   console.log(this.selectedPillar)
    // },
    // showNewPillarInput() {
    //   this.dropdownTitle = 'Create New Pillar'
    //   this.isVisibleNewPillarInput = true
    //   this.isVisibleExistingPillarInput = false
    // },
    // addExistingPillar(pillarID, pillarName, description) {
    //   this.dropdownTitle = pillarName
    //   this.isVisibleNewPillarInput = false
    //   this.isVisibleExistingPillarInput = true
    //   this.pillarID = pillarID
    //   this.pillarName = pillarName
    //   this.description = description
    // },
    clonePillar(pillar) {
      this.pillarClone = JSON.parse(JSON.stringify(pillar))
      console.log(this.pillarClone)
    },
    createPillar() {
      this.$store.commit('creator/strategy/insertPillar', this.pillarName)
      this.setHasChanges('create', {
        pillar: {
          change: 'create',
        },
      })
      this.pillarName = null
      // if (!this.isVisibleExistingPillarInput) {
      //   firebaseDatabase.collection('pillars')
      //     .add({
      //       userID: firebaseAuth.currentUser.uid,
      //       pillarName: this.pillarName,
      //       active: true,
      //       description: '',
      //     })
      //     .then((docRef) => {
      //       console.log(docRef.id)
      //       const newPillar = {
      //         pillarID: docRef.id,
      //         userID: firebaseAuth.currentUser.uid,
      //         pillarName: this.pillarName,
      //         active: true,
      //         description: '',
      //       }
      //       this.$store.dispatch('strategy/pillars/insertPillar', newPillar)
      //     })
      // } else this.activateExistingPillar()
    },
    // activateExistingPillar() {
    //   const newPillar = {
    //     pillarID: this.pillarID,
    //     userID: firebaseAuth.currentUser.uid,
    //     pillarName: this.pillarName,
    //     active: true,
    //     description: this.description,
    //   }
    //   firebaseDatabase.collection('pillars').doc(this.pillarID)
    //     .update({
    //       active: true,
    //     })
    //     .then(this.$store.dispatch('strategy/pillars/insertPillar', newPillar))
    // },
    // resetNewPillar() {
    //   this.dropdownTitle = 'Choose Pillar'
    //   this.isVisibleNewPillarInput = false
    //   this.isVisibleExistingPillarInput = false
    // },
    updatePillar(pillar) {
      console.log(this.pillarClone)
      this.setHasChanges('update', this.pillarClone)
      const updatedPillar = this.pillarClone
      this.$store.commit('creator/strategy/updatePillar', updatedPillar)
      this.pillarClone = null
      // if (!this.selectedPillar.active) {
      //   const removedPillar = this.selectedPillar
      //   console.log(removedPillar)
      //   firebaseDatabase.collection('pillars').doc(this.selectedPillar.pillarID).update({
      //     pillarName: this.selectedPillar.pillarName,
      //     active: this.selectedPillar.active,
      //     description: this.selectedPillar.description,
      //   })
      //     .then(this.$store.dispatch('strategy/pillars/removePillar', removedPillar))
      // } else {
      //   firebaseDatabase.collection('pillars').doc(this.selectedPillar.pillarID).update({
      //     pillarName: this.selectedPillar.pillarName,
      //     active: this.selectedPillar.active,
      //     description: this.selectedPillar.description,
      //   })
      // }
    },
    removePillar(pillar) {
      console.log(pillar)
      this.$store.commit('creator/strategy/removePillar', {
        pillar,
      })
      this.setHasChanges('delete', pillar)
    },
    setHasChanges(type, pillar) {
      this.$store.commit('creator/hasChanges')
      if (type === 'delete') {
      } else if (pillar.change === 'create') {
      } else pillar.change = 'update'
    },
    // deactivatePillar() {
    //   this.selectedPillar.active = !this.selectedPillar.active
    // },
  },
}
</script>
<style lang="scss" module>
  @import './style.module.scss';
</style>
